import { Record, List } from 'immutable';
export default Record({
  enrollmentErrors: List(),
  enrollmentWarnings: List()
});